import Typography from '@mui/material/Typography';
import { useStore } from '../../app/stores/store';
import Login from '../user/forms/Login';
import { admin, t1aAdmin} from '../../app/common/options/adminOptions';
import { router } from '../../app/router/Routes';
import { Avatar, Box, Button } from '@mui/material';

interface Props {
    imgUrl: string;
    title: string;
    description: string;
    haveLink: boolean;
    boxStyle: object;
    index: number;
    iconWidthHeight: any;
    btn?: boolean;
    bigTitle?: boolean;
}
const styles = {

    link: {
        color: '#0000ff',
        cursor: 'pointer'
    } as const,
};
export default function ArsCard({ imgUrl, title, description, haveLink, boxStyle, index, iconWidthHeight, btn, bigTitle }: Props) {

    const { userStore, modalStore } = useStore();
    const { isLoggedIn, user } = userStore;

    const GetCRFLink = () => {
        return <span>Choose a logistics solution when <strong><span style={styles.link}
            onClick={() => { (!user || !isLoggedIn) ? modalStore.openModal(<Login />) : router.navigate(user && (user!.currentUserRole !== t1aAdmin && user!.currentUserRole !== admin) ? '/userProfile' : '/') }}>filling in a CRF.</span>
        </strong> Contact Tier1 Asset's department of logistics if you need assistance: <strong><a href='mailto:logistik@tier1asset.com' style={{ textDecoration: 'none' }}>logistik@tier1asset.com</a></strong></span>
    }
    const GetLogisticLink = () => {
        return <span>You benefit from global logistics. Tier1 Asset (T1A) coordinates the planning process for the pickup of goods for any global or local customer. For more details <strong><a style={styles.link} href='https://tier1asset.com/pakningsvejledning/' target="_blank" rel="noreferrer">check out our packing instructions.</a></strong></span>
    }
    return (
        <Box component={'div'} sx={boxStyle}>
            <Box>
                <Avatar alt={title} src={imgUrl} sx={iconWidthHeight} />
            </Box>
            <Box>
                <Typography variant={bigTitle ? "h4" : "h6"} textAlign='center' sx={{ p: 2 }} >
                    <strong>{title}</strong></Typography>
            </Box>
            <Box sx={{ height: 130, overflow: 'hidden' }}>
                <Typography variant="body2" textAlign='center' fontSize={16} sx={{ lineHeight: 1.6 }}>
                    {description}
                </Typography>
            </Box>
            <Box sx={{ p: 2, textAlign: 'center' }}>
                {btn &&
                    <Button variant='contained' size='large'
                        sx={{
                            bgcolor: '#003755',
                            borderRadius: '10px',
                            width: 150,
                            fontSize: 14,
                            '&:hover': {
                                backgroundColor: '#015482',
                                opacity: [0.9, 0.8, 0.7],
                            },
                        }}>LEARN MORE
                    </Button>
                }
            </Box>
        </Box>
    );
}
